import { CONSTANTS } from '@constants';

export const REQUESTED = 'REQUESTED';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const UPDATE_FIELD = 'userreport/UPDATE_FIELD';
export const UPDATE_CUSTOM_FIELD = 'userreport/UPDATE_CUSTOM_FIELD';
export const UPDATE_PAGE = 'userreport/UPDATE_PAGE';
export const UPDATE_CUTOM_PAGE = 'userreport/UPDATE_CUTOM_PAGE';
export const CLEAR_STATE = 'userreport/CLEAR_STATE';

export const GET_SENDERLIST_REQUESTED = 'userreport/GET_SENDERLIST_REQUESTED';
export const GET_SENDERLIST_SUCCESS = 'userreport/GET_SENDERLIST_SUCCESS';
export const GET_SENDERLIST_FAILURE = 'userreport/GET_SENDERLIST_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  tableData: {},
  initialData: {
    selectedReportIds: [],
    pageNo: 0,
    sortBy: 'updatedTS',
    orderBy: 'desc',
    activePage: 1,
    searchKey: '',
    searchCampaign: '',
    sendReport: '',
    senderList: '',
    selectedMethod: '',
    selectedPeriod: '',
    selectedPeriodFrom: '',
    selectedPeriodEnd: '',
    selectedPeriodYear: null,
    selectedPeriodMonth: null,
    selectedPeriodWeek: null,
    checkboxArray: [],
    headers: [
      {
        title: 'Actions',
        slug: 'actions',
        isVisible: false,
        width: 50,
      },
      {
        title: CONSTANTS.USER_ID,
        slug: 'user_id',
        isVisible: true,
        width: 130,
      },
      {
        title: CONSTANTS.CAMPAIGN_NAME,
        slug: 'compaign_name',
        isVisible: true,
        width: 110,
      },
      {
        title: CONSTANTS.ACTIVITY_INTEGRATION,
        slug: 'activity_integration',
        center: true,
        isVisible: true,
        width: 140,
      },
      {
        title: CONSTANTS.OFFER_WON,
        slug: 'totalOfferWon',
        center: true,
        isVisible: true,
        width: 110,
      },
      {
        title: CONSTANTS.TOTAL_OFFER,
        slug: 'totalOffer',
        isVisible: true,
        width: 110,
        centre: true
      },
      {
        title: CONSTANTS.OFFER_REDEEMED,
        slug: 'totalOfferRedeem',
        center: true,
        isVisible: true,
        width: 110,
      },
    ]
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUESTED:
    {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case SUCCESS:
    {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case FAILURE:
    {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_FIELD: {
      const initialData = { ...state.initialData, ...action.payload };
      return { ...state, initialData };
    }
    case UPDATE_CUSTOM_FIELD: {
      const tableData = { ...state.tableData, ...action.payload };
      return { ...state, tableData };
    }
    case UPDATE_PAGE: {
      const initialData = { ...state.initialData, ...action.payload };
      return { ...state, initialData };
    }
    case UPDATE_CUTOM_PAGE: {
      const initialData = { ...state.initialData, ...action.payload };
      return { ...state, initialData };
    }
    case CLEAR_STATE: {
      return { ...initialState };
    }
    case GET_SENDERLIST_REQUESTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_SENDERLIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case GET_SENDERLIST_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }
    default:
      return state;
  }
};

export const clearState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const getUserReport = (data) => {
  return {
    types: [REQUESTED, SUCCESS, FAILURE],
    promise: client => client.get(`getUserReport/${data.itemsPerPage}/${data.pageNo}?searchKey=${data.searchKey}&sortBy=${data.sortBy}&orderBy=${data.orderBy}&selectedPeriodFrom=${data.selectedPeriodFrom}&selectedPeriodEnd=${data.selectedPeriodEnd}`)
  };
};

export const downloadUserReport = (data) => {
  return {
    types: [REQUESTED, SUCCESS, FAILURE],
    promise: client => client.get(`downloadUserReport?selectedPeriodFrom=${data.selectedPeriodFrom}&selectedPeriodEnd=${data.selectedPeriodEnd}&idList=${data.idList}`)
  };
};

export const sendNowUserReport = (data) => {
  return {
    types: [GET_SENDERLIST_REQUESTED, GET_SENDERLIST_SUCCESS, GET_SENDERLIST_FAILURE],
    promise: client => client.get(`sendNowUserReport?selectedPeriodFrom=${data.selectedPeriodFrom}&selectedPeriodEnd=${data.selectedPeriodEnd}&emailList=${data.emailList}&idList=${data.idList}`)
  };
};

// action
export const updateFields = (payload) => {
  return {
    type: UPDATE_FIELD,
    payload,
  };
};

export const updatecustomFields = (payload) => {
  return {
    type: UPDATE_CUSTOM_FIELD,
    payload,
  };
};

export const updatePage = (payload) => {
  return {
    type: UPDATE_PAGE,
    payload,
  };
};

export const updateCustomPage = (payload) => {
  return {
    type: UPDATE_CUTOM_PAGE,
    payload,
  };
};
